<mat-nav-list>
    <div class="whiteLogo" class="whiteLogo" routerLink="/home" routerLinkActive="home-is-active">
        <picture>
            <source [srcset]="whiteLogoWebp" type="image/webp">
            <img [src]="whiteLogo" class="whiteLogo" alt="whiteLogo de CDFL">
        </picture>
    </div>
    <a mat-list-item routerLink="/home" (click)="onSidenavClose()">
        <mat-icon>home</mat-icon> <span class="nav-caption"> Accueil</span>
    </a>
    <a mat-list-item routerLink="/qualified" (click)="onSidenavClose()">
        <mat-icon>stars</mat-icon> <span class="nav-caption"> Joueurs Qualifiés</span>
    </a>
    <a mat-list-item routerLink="/events" (click)="onSidenavClose()">
        <mat-icon>event</mat-icon> <span class="nav-caption"> Tournois</span>
    </a>
    <a mat-list-item routerLink="/addqualified" (click)="onSidenavClose()">
        <mat-icon>add</mat-icon> <span class="nav-caption"> Ajouter un qualifié</span>
    </a>
    <a mat-list-item routerLink="/circuit" (click)="onSidenavClose()">
        <mat-icon>info</mat-icon> <span class="nav-caption"> Informations sur le Circuit</span>
    </a>
    <a mat-list-item routerLink="/final" (click)="onSidenavClose()">
        <mat-icon>emoji_events</mat-icon> <span class="nav-caption"> Informations sur la Finale</span>
    </a>
    <a mat-list-item routerLink="/faq" (click)="onSidenavClose()">
        <mat-icon>question_answer</mat-icon> <span class="nav-caption"> FAQ</span>
    </a>
</mat-nav-list>